<template>
  <div class="dashboard-container">
    <el-row class="tcf-row" style="padding: 0">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>

            <div style="float: right;">
              <el-form-item>
                <el-button :loading="btnLoading" icon="el-icon-printer" @click="exportAfterExcel">导出售后赔款Excel</el-button>
              </el-form-item>
              <el-form-item>
                <el-button :loading="btnLoading" icon="el-icon-printer" @click="exportRebaceExcel">导出返点Excel</el-button>
              </el-form-item>
              <el-form-item label="导出日期">
                <el-date-picker
                  style="width: 100%;"
                  v-model="searchForm.date"
                  type="date"
                  placeholder="选择导出日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-tooltip effect="dark" content="导出日期选择后将导出对应日期的历史数据，不选择时默认导出实时数据" placement="top">
                  <el-button :loading="btnLoading" icon="el-icon-printer" @click="exportExcel">导出Excel</el-button>
                </el-tooltip>
              </el-form-item>
            </div>
          </el-form>
          <div class="card-content">
            <el-col v-loading="tableLoading" :span="24">
              <el-table
                :data="tableData"
                stripe
                :row-style="{cursor: 'pointer'}"
                style="width: 100%"
                @row-click="goDealerAccount"
              >
                <el-table-column
                  label="经销商"
                  width="160"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.all_name }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="人员信息"
                  width="150"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span>区域经理：{{ scope.row.areaName }}</span><br />
                    <span>跟单客服：{{ scope.row.serveName }}</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column
                  label="意向金"
                  width="120"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.inmon>0" style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.inmon }}</span>
                    <span v-if="scope.row.inmon<=0" style="color:#99a9bf;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.inmon }}</span>
                  </template>
                </el-table-column> -->
                <el-table-column
                  label="样品预存款"
                  width="120"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.joinn>0" style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.joinn }}</span>
                    <span v-if="scope.row.joinn<=0" style="color:#99a9bf;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.joinn }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="加盟费"
                  width="120"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.insure>0" style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.insure }}</span>
                    <span v-if="scope.row.insure<=0" style="color:#99a9bf;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.insure }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="账户余额"
                  width="120"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <!-- <span style="color:#99a9bf">{{scope.row.accountname}}：</span> -->
                    <span v-if="scope.row.balance>0" style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.balance }}</span>
                    <span v-if="scope.row.balance<=0" style="color:#99a9bf;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.balance }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="冲业绩余额"
                  width="120"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.achievement_balance>0" style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.achievement_balance }}</span>
                    <span v-if="scope.row.achievement_balance<=0" style="color:#99a9bf;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.achievement_balance }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="业绩/支票返点"
                  width="120"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.rebate_balance>0" style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.rebate_balance }}</span>
                    <span v-if="scope.row.rebate_balance<=0" style="color:#99a9bf;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.rebate_balance }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="售后赔款"
                  width="120"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.after_balance>0" style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.after_balance }}</span>
                    <span v-if="scope.row.after_balance<=0" style="color:#99a9bf;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.after_balance }}</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column
                  label="报备金"
                  min-width="120"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.report_balance>0" style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.report_balance }}</span>
                    <span v-if="scope.row.report_balance<=0" style="color:#99a9bf;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.report_balance }}</span>
                  </template>
                </el-table-column> -->
                <el-table-column label="退商时间" prop="retime" width="120">
                  <template slot-scope="scope">
                    <span>{{ scope.row.retime || '--' }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  min-width="330"
                  fixed="right"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <el-button size="mini" icon="el-icon-money" @click.stop="recharge(scope.row)">充值</el-button>
                    <el-button size="mini" icon="el-icon-money" @click.stop="other(scope.row)">其他收款</el-button>
                    <el-button size="mini" icon="el-icon-money" @click.stop="deepen(scope.row)">深化收款</el-button>
                    <br />
                    <div style="height: 10px; width: 100%;"></div>
                    <el-button size="mini" icon="el-icon-money" @click.stop="performance(scope.row)">冲业绩</el-button>
                    <el-button size="mini" icon="el-icon-money" @click.stop="joinApply(scope.row)">样品预存款申请</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                v-if="total>0"
                background
                :current-page="currentPage"
                :page-sizes="[20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </el-col>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-dialog
      title="经销商账户充值"
      :visible.sync="editVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editForm" v-loading="infoLoading" :model="editForm" :rules="editRules" label-position="right" label-width="90px" size="small">
        <!-- <el-form-item v-if="audittime!==null&&audittime!==''" label="审核信息">
          <el-card class="box-card">
            <div style="color:#606266;font-size: 13px;">
              <span><span style="color:#99a9bf">审核时间：</span>{{ audittime }}</span>
              <span style="margin-left: 30px;"><span style="color:#99a9bf">审核人：</span>{{ auditname }}</span>
            </div>
            <div v-if="auditrson!=''&&auditrson!=null" style="color:#606266;font-size: 13px;">
              <span style="color:#99a9bf">拒绝原因：</span>{{ auditrson }}
            </div>
          </el-card>
        </el-form-item> -->
        <el-form-item label="经销商" prop="delid">
          <el-input v-model="editForm.dealerName" :disabled="true" />
        </el-form-item>
        <el-form-item label="打款账户" prop="aid">
          <el-select v-model="editForm.aid" style="width:100%" placeholder="请选择" clearable filterable>
            <el-option-group
              v-for="gitem in groupList"
              v-if="gitem.nature===0"
              :key="gitem.groupid"
              :label="gitem.account_name"
            >
              <el-option
                v-for="item in accountsList"
                v-if="item.groupid===gitem.groupid"
                :key="item.aid"
                :label="item.name+'（'+item.card+'）'"
                :value="item.aid"
              >
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.card }}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="打款性质" prop="nature">
          <el-select v-model="editForm.nature">
            <el-option
              v-for="item in receiptNatureList"
              :key="item.rntid"
              :label="item.name"
              :value="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="打款日期" prop="receipttime">
          <el-date-picker
            v-model="editForm.receipttime"
            type="date"
            style="width:240px"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="打款金额" prop="money">
          <el-input v-model="editForm.money" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item label="卡号" prop="card">
          <el-input v-model="editForm.card" maxlength="100" placeholder="请输入汇款人“卡号/尾号”，例如“张三/1234”" show-word-limit />
        </el-form-item>
        <el-form-item label="打款凭证" prop="imgids">
          <MultiImg :key="imgLoad" v-model="editForm.imgids" :limit="9" :size="'sm'" :old="editimgList" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="editForm.remark" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subEdit('editForm')">立即提交</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="冲业绩"
      :visible.sync="cyjVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="cyjForm" v-loading="cyjloading" :model="cyjForm" :rules="cyjRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="经销商" prop="delid">
          <el-input v-model="cyjForm.dealerName" :disabled="true" />
        </el-form-item>
        <el-form-item label="打款性质" prop="nature">
          <el-radio-group v-model="cyjForm.nature">
            <el-radio label="银行收款">银行收款</el-radio>
            <el-radio label="账户抵扣">账户抵扣</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="cyjForm.nature == '银行收款'" label="打款账户" prop="aid">
          <el-select v-model="cyjForm.aid" style="width:100%" placeholder="请选择" clearable filterable>
            <el-option-group
              v-for="gitem in groupList"
              v-if="gitem.nature===0"
              :key="gitem.groupid"
              :label="gitem.account_name"
            >
              <el-option
                v-for="item in accountsList"
                v-if="item.groupid===gitem.groupid"
                :key="item.aid"
                :label="item.name+'（'+item.card+'）'"
                :value="item.aid"
              >
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.card }}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="打款性质" prop="nature">
          <el-select v-model="cyjForm.nature">
            <el-option
              v-for="item in receiptNatureList"
              :key="item.rntid"
              :label="item.name"
              :value="item.name"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item label="打款日期" prop="receipttime">
          <el-date-picker
            v-model="cyjForm.receipttime"
            type="date"
            style="width:240px"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="打款金额" prop="money">
          <el-input v-model="cyjForm.money" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item v-if="cyjForm.nature == '银行收款'" label="卡号" prop="card">
          <el-input v-model="cyjForm.card" maxlength="100" placeholder="请输入汇款人“卡号/尾号”，例如“张三/1234”" show-word-limit />
        </el-form-item>
        <el-form-item v-if="cyjForm.nature == '银行收款'" label="打款凭证" prop="imgids">
          <MultiImg :limit="9" :size="'sm'" :old="oldCyjImgs" :key="cyjImgKey" v-model="cyjForm.imgids" />
        </el-form-item>
        <el-form-item label="冲业绩名称" prop="name">
          <el-input v-model="cyjForm.name" maxlength="100" show-word-limit placeholder="请输入" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="cyjForm.remark" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="cyjloading" @click="cyjApplyEdit('cyjForm')">立即提交</el-button>
          <el-button @click="cyjVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="其他收款"
      :visible.sync="otherVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="otherForm" v-loading="otherloading" :model="otherForm" :rules="otherRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="经销商" prop="delid">
          <el-input v-model="otherForm.dealerName" :disabled="true" />
        </el-form-item>
        <el-form-item label="打款性质" prop="nature">
          <el-radio-group v-model="otherForm.nature">
            <el-radio label="银行收款">银行收款</el-radio>
            <el-radio label="账户抵扣">账户抵扣</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="otherForm.nature == '银行收款'" label="打款账户" prop="aid">
          <el-select v-model="otherForm.aid" style="width:100%" placeholder="请选择" clearable filterable>
            <el-option-group
              v-for="gitem in groupList"
              v-if="gitem.nature===0"
              :key="gitem.groupid"
              :label="gitem.account_name"
            >
              <el-option
                v-for="item in accountsList"
                v-if="item.groupid===gitem.groupid"
                :key="item.aid"
                :label="item.name+'（'+item.card+'）'"
                :value="item.aid"
              >
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.card }}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="打款日期" prop="receipttime">
          <el-date-picker
            v-model="otherForm.receipttime"
            type="date"
            style="width:240px"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="打款金额" prop="money">
          <el-input v-model="otherForm.money" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item v-if="otherForm.nature == '银行收款'" label="卡号" prop="card">
          <el-input v-model="otherForm.card" maxlength="100" placeholder="请输入汇款人“卡号/尾号”，例如“张三/1234”" show-word-limit />
        </el-form-item>
        <el-form-item v-if="otherForm.nature == '银行收款'" label="打款凭证" prop="imgids">
          <MultiImg :limit="9" :size="'sm'" :old="oldOtherImgs" :key="otherImgKey" v-model="otherForm.imgids" />
        </el-form-item>
        <el-form-item label="收款事项" prop="name">
          <el-input v-model="otherForm.name" maxlength="100" show-word-limit placeholder="请输入" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="otherForm.remark" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="otherloading" @click="otherApplyEdit('otherForm')">立即提交</el-button>
          <el-button @click="otherVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="深化收款"
      :visible.sync="deepenVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="deepenForm" v-loading="deepenloading" :model="deepenForm" :rules="deepenRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="经销商" prop="delid">
          <el-input v-model="deepenForm.dealerName" :disabled="true" />
        </el-form-item>
        <el-form-item label="打款性质" prop="nature">
          <el-radio-group v-model="deepenForm.nature">
            <el-radio label="银行收款">银行收款</el-radio>
            <el-radio label="账户抵扣">账户抵扣</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="deepenForm.nature == '银行收款'" label="打款账户" prop="aid">
          <el-select v-model="deepenForm.aid" style="width:100%" placeholder="请选择" clearable filterable>
            <el-option-group
              v-for="gitem in groupList"
              v-if="gitem.nature===0"
              :key="gitem.groupid"
              :label="gitem.account_name"
            >
              <el-option
                v-for="item in accountsList"
                v-if="item.groupid===gitem.groupid"
                :key="item.aid"
                :label="item.name+'（'+item.card+'）'"
                :value="item.aid"
              >
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.card }}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="打款日期" prop="receipttime">
          <el-date-picker
            v-model="deepenForm.receipttime"
            type="date"
            style="width:240px"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="打款金额" prop="money">
          <el-input v-model="deepenForm.money" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item v-if="deepenForm.nature == '银行收款'" label="卡号" prop="card">
          <el-input v-model="deepenForm.card" maxlength="100" placeholder="请输入汇款人“卡号/尾号”，例如“张三/1234”" show-word-limit />
        </el-form-item>
        <el-form-item label="打款凭证" prop="imgids">
          <MultiImg :limit="9" :size="'sm'" :old="oldDeepenImgs" :key="deepenImgKey" v-model="deepenForm.imgids" />
        </el-form-item>
        <!-- <el-form-item label="收款事项" prop="name">
          <el-input v-model="deepenForm.name" maxlength="100" show-word-limit placeholder="请输入" />
        </el-form-item> -->
        <el-form-item label="备注" prop="remark">
          <el-input v-model="deepenForm.remark" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="deepenloading" @click="deepenApplyEdit('deepenForm')">立即提交</el-button>
          <el-button @click="deepenVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="经销商样品预存款申请"
      :visible.sync="joinVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="joinForm" :model="joinForm" :rules="joinRules"  label-position="right" label-width="75px" size="small">
        <el-form-item label="经销商" prop="dealerName">
          <el-input v-model="joinForm.dealerName" :disabled="true" />
        </el-form-item>
        <el-form-item label="店面形式" prop="shopform">
          <el-select v-model="joinForm.shopform" style="width:100%" placeholder="请选择">
            <el-option
              v-for="item in dmxsList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="总面积" prop="totalarea">
          <el-input v-model="joinForm.totalarea" maxlength="20" placeholder="请输入店面总面积" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="品牌占用面积" prop="area">
          <el-input v-model="joinForm.area" maxlength="20" placeholder="请输入品牌占用面积" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="门店地址" prop="address">
          <el-input v-model="joinForm.address" maxlength="1000" placeholder="请输入门店地址" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="打款账户" prop="aid">
          <el-select v-model="joinForm.aid" style="width:100%" placeholder="请选择" clearable filterable>
            <el-option-group
              v-for="gitem in groupList"
              v-if="gitem.nature===0"
              :key="gitem.groupid"
              :label="gitem.account_name">
              <el-option
                v-for="item in accountsList"
                v-if="item.groupid===gitem.groupid"
                :key="item.aid"
                :label="item.name+'（'+item.card+'）'"
                :value="item.aid">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.card }}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="打款日期" prop="receipttime">
          <el-date-picker
            v-model="joinForm.receipttime"
            type="date"
            style="width:240px"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="打款金额" prop="money">
          <el-input v-model="joinForm.money" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item label="卡号" prop="card">
          <el-input v-model="joinForm.card" maxlength="100" placeholder="请输入汇款人“卡号/尾号”，例如“张三/1234”" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="打款凭证" prop="imgids">
          <MultiImg :limit="9" :size="'sm'" :old="oldJoinImgs" :key="joinImgKey" v-model="joinForm.imgids" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="joinForm.remark" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="joinloading" @click="joinApplyEdit('joinForm')">立即提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDealerAccountList, excelDealerAccountList, excelAfterAccountList, excelRebaceAccountList } from '@/api/work'
import { getDealerAccountData } from '@/api/dealer'
import { getReceiptNature, addOrEditCollectApply, addOrEditDealerJoinApply, addOrEditAchievementApply, addOrEditOtherApply } from '@/api/erp'
import { getAccounts, getGroupReport } from '@/api/pub'
import MultiImg from '@/components/upload/MultiImg'

export default {
  components: {
    MultiImg
  },
  data() {
    return {
      editVisible: false,
      editloading: false,
      btnLoading: false,
      infoLoading: false,
      isSingleAccount: true,
      imgLoad: '',
      editimgList: [],
      groupList: [],
      receiptNatureList: [],
      accountsList: [],
      accountData: [],
      editForm: {
        dealerName: '',
        raid: '',
        delid: '',
        aid: null,
        receipttime: '',
        money: null,
        card: '',
        nature: '',
        remark: '',
        imgids: []
      },
      editRules: {
        delid: [{ required: true, message: '请选择经销商', trigger: 'change' }],
        aid: [{ required: true, message: '请选择打款账户', trigger: 'change' }],
        receipttime: [{ required: true, message: '请选择打款日期', trigger: 'change' }],
        money: [{ required: true, message: '请输入打款金额', trigger: 'blur' }],
        // card: [{ required: true, message: '请输入卡号', trigger: 'blur' }],
        nature: [{ required: true, message: '请选择打款性质', trigger: 'blur' }],
        imgids: [{ required: true, message: '请上传打款凭证', trigger: 'change' }]
      },
      searchForm: {
        search: '',
        date: '',
      },
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableLoading: false,
      tableData: [],

      joinVisible: false,
      joinloading: false,
      joinImgKey: '',
      oldJoinImgs: [],
      joinImgList: [],
      joinForm: {},
      joinRules: {
        aid: [{ required: true, message: '请选择打款账户', trigger: 'change' }],
        receipttime: [{ required: true, message: '请选择打款日期', trigger: 'change' }],
        money: [{ required: true, message: '请输入打款金额', trigger: 'blur' }],
        // card: [{ required: true, message: '请输入汇款人卡号', trigger: 'blur' }],
        imgids: [{ required: true, message: '请上传打款凭证', trigger: 'change' }],
        shopform: [{ required: true, message: '请选择店面形式', trigger: 'change' }],
        totalarea: [{ required: true, message: '请输入总面积', trigger: 'blur' }],
        area: [{ required: true, message: '品牌占用面积', trigger: 'blur' }],
        address: [{ required: true, message: '请输入门店地址', trigger: 'blur' }]
      },
      dmxsList: [{ id: 0, name: '商场内店' }, { id: 1, name: '店中店' }, { id: 2, name: '沿街店' }],

      cyjVisible: false,
      cyjloading: false,
      cyjImgKey: '',
      oldCyjImgs: [],
      cyjImgList: [],
      cyjForm: {
        nature: '银行收款'
      },
      cyjRules: {
        delid: [{ required: true, message: '请选择经销商', trigger: 'change' }],
        aid: [{ required: true, message: '请选择打款账户', trigger: 'change' }],
        receipttime: [{ required: true, message: '请选择打款日期', trigger: 'change' }],
        money: [{ required: true, message: '请输入打款金额', trigger: 'blur' }],
        // card: [{ required: true, message: '请输入卡号', trigger: 'blur' }],
        nature: [{ required: true, message: '请选择打款性质', trigger: 'blur' }],
        name: [{ required: true, message: '请输入冲业绩名称', trigger: 'blur' }],
        imgids: [{ required: true, message: '请上传打款凭证', trigger: 'change' }]
      },

      otherVisible: false,
      otherloading: false,
      otherImgKey: '',
      oldOtherImgs: [],
      otherImgList: [],
      otherForm: {
        nature: '银行收款'
      },
      otherRules: {
        delid: [{ required: true, message: '请选择经销商', trigger: 'change' }],
        aid: [{ required: true, message: '请选择打款账户', trigger: 'change' }],
        receipttime: [{ required: true, message: '请选择打款日期', trigger: 'change' }],
        money: [{ required: true, message: '请输入打款金额', trigger: 'blur' }],
        nature: [{ required: true, message: '请选择打款性质', trigger: 'blur' }],
        name: [{ required: true, message: '请输入收款内容', trigger: 'blur' }],
        imgids: [{ required: true, message: '请上传打款凭证', trigger: 'change' }]
      },

      deepenVisible: false,
      deepenloading: false,
      deepenImgKey: '',
      oldDeepenImgs: [],
      deepenImgList: [],
      deepenForm: {
        nature: '银行收款'
      },
      deepenRules: {
        delid: [{ required: true, message: '请选择经销商', trigger: 'change' }],
        aid: [{ required: true, message: '请选择打款账户', trigger: 'change' }],
        receipttime: [{ required: true, message: '请选择打款日期', trigger: 'change' }],
        money: [{ required: true, message: '请输入打款金额', trigger: 'blur' }],
        nature: [{ required: true, message: '请选择打款性质', trigger: 'blur' }],
        name: [{ required: true, message: '请输入收款内容', trigger: 'blur' }],
        imgids: [{ required: true, message: '请上传打款凭证', trigger: 'change' }]
      },
    }
  },
  computed: {
    user: getUser,
    pickerOptions() {
      return {
        disabledDate(time) {
          // 上线日期 之前没有数据
          return new Date('2025-06-19').getTime() >= time.getTime() || time.getTime() >= Date.now() - 24 * 3600 * 1000
        }
      }
    },
  },
  created() {
    // console.log(this.user.dGroupid)
    this.getDealerAccountList()
    getGroupReport().then(response => {
      this.groupList = response.data
      // .filter(i => i.groupid === this.user.dGroupid)
    }).catch(() => {})
    getAccounts().then(response => {
      this.accountsList = response.data
    }).catch(() => {})
    getReceiptNature().then(response => {
      this.receiptNatureList = response.data
    }).catch(() => {})
  },
  methods: {
    recharge(row) {
      this.editVisible = true
      this.editForm.dealerName = row.all_name
      this.editForm.delid = row.dealer_id
      // this.infoLoading = true
      getDealerAccountData({ delid: row.dealer_id }).then(response => {
        this.accountData = response.data
        if (this.accountData.length > 1) {
          this.isSingleAccount = false
        }
      }).catch(() => {
      })
      // console.log(row, this.user)
      // this.$router.push({ path: '/work/delzhgl' })
    },
    // 其他收款
    other(row) {
      this.otherVisible = true
      this.otherForm.nature = '银行收款'
      this.otherForm.dealerName = row.all_name
      this.otherForm.delid = row.dealer_id
      this.otherForm.balance = row.balance
      getDealerAccountData({ delid: row.dealer_id }).then(response => {
        this.accountData = response.data
        if (this.accountData.length > 1) {
          this.isSingleAccount = false
        }
      }).catch(() => { })
    },
    // 深化收款
    deepen(row) {
      this.deepenVisible = true
      this.deepenForm.nature = '银行收款'
      this.deepenForm.name = '深化收款'
      this.deepenForm.dealerName = row.all_name
      this.deepenForm.delid = row.dealer_id
      this.deepenForm.balance = row.balance
      this.deepenRules.imgids[0].required = this.deepenForm.nature === '银行收款'
      getDealerAccountData({ delid: row.dealer_id }).then(response => {
        this.accountData = response.data
        if (this.accountData.length > 1) {
          this.isSingleAccount = false
        }
      }).catch(() => { })
    },
    performance(row) {
      this.cyjVisible = true
      this.cyjForm.nature = '银行收款'
      this.cyjForm.dealerName = row.all_name
      this.cyjForm.delid = row.dealer_id
      this.cyjForm.balance = row.balance
      getDealerAccountData({ delid: row.dealer_id }).then(response => {
        this.accountData = response.data
        if (this.accountData.length > 1) {
          this.isSingleAccount = false
        }
      }).catch(() => { })
    },
    subEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            const data = {
              userid: this.user.dUserid,
              role: 1,
              applyid: 0,
              dealerid: this.editForm.delid,
              date: this.editForm.receipttime,
              money: this.editForm.money,
              accountid: this.editForm.aid,
              card: this.editForm.card,
              nature: this.editForm.nature,
              imgStr: this.editForm.imgids.join(','),
              remark: this.editForm.remark,
              paycontent: '账户充值'
            }
            addOrEditCollectApply(data).then(response => {
              this.$message({
                message: '打款申请提交成功',
                type: 'success'
              })
              this.editForm = {
                dealerName: '',
                raid: '',
                delid: '',
                aid: null,
                receipttime: '',
                money: null,
                card: '',
                nature: '',
                remark: '',
                imgids: []
              }
              this.editVisible = false
              this.editloading = false
              this.editimgList = []
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    // 样品预存款打款
    joinApply(row) {
      this.joinForm.dealerName = row.all_name
      this.joinForm.delid = row.dealer_id
      this.joinVisible = true
    },
    joinApplyEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid)return false;
        if (this.joinloading) return false;
        this.joinloading = true
        const data = {
          djaid: 0,
          userid: this.user.dUserid,
          groupid: this.user.dGroupid,
          dealerid: this.joinForm.delid,
          date: this.joinForm.receipttime,
          money: this.joinForm.money,
          accountid: this.joinForm.aid,
          card: this.joinForm.card,
          imgStr: this.joinForm.imgids.join(','),
          remark: this.joinForm.remark,
          shopform: this.joinForm.shopform,
          totalarea: this.joinForm.totalarea,
          area: this.joinForm.area,
          address: this.joinForm.address
        }
        addOrEditDealerJoinApply(data).then(response => {
          this.$message({
            message: '样品预存款打款申请提交成功',
            type: 'success'
          })
          this.joinForm = {}
          this.joinVisible = false
          this.joinloading = false
          this.joinImgList = []
          this.getData()
        }).catch(() => {
          this.joinloading = false
        })
      })
    },

    // 冲业绩
    cyjApplyEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid)return false;
        if (this.cyjForm.nature == '账户抵扣' && this.cyjForm.balance < this.cyjForm.money) {
          this.$message({
            message: '账户余额不足',
            type: 'warning'
          })
          return false;
        }
        if (this.cyjloading) return false;
        this.cyjloading = true
        const data = {
          applyid: 0,
          userid: this.user.dUserid,
          groupid: this.user.dGroupid,
          nature: this.cyjForm.nature,
          delid: this.cyjForm.delid,
          receipttime: this.cyjForm.receipttime,
          amount: this.cyjForm.money,
          aid: this.cyjForm.aid,
          card: this.cyjForm.card,
          img: this.cyjForm.imgids ? this.cyjForm.imgids.join(',') : '',
          name: this.cyjForm.name,
          remark: this.cyjForm.remark
        }
        addOrEditAchievementApply(data).then(response => {
          this.$message({
            message: '冲业绩申请提交成功',
            type: 'success'
          })
          this.cyjForm = {
            nature: '银行收款'
          }
          this.cyjVisible = false
          this.cyjloading = false
          this.cyjImgList = []
          this.getData()
        }).catch(() => {
          this.cyjloading = false
        })
      })
    },

    // 其他收款
    otherApplyEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid)return false;
        if (this.otherForm.nature == '账户抵扣' && this.otherForm.balance < this.otherForm.money) {
          this.$message({
            message: '账户余额不足',
            type: 'warning'
          })
          return false;
        }
        if (this.otherloading) return false;
        this.otherloading = true
        const data = {
          applyid: 0,
          userid: this.user.dUserid,
          groupid: this.user.dGroupid,
          nature: this.otherForm.nature,
          delid: this.otherForm.delid,
          receipttime: this.otherForm.receipttime,
          amount: this.otherForm.money,
          aid: this.otherForm.aid,
          card: this.otherForm.card,
          img: this.otherForm.imgids ? this.otherForm.imgids.join(',') : '',
          name: this.otherForm.name,
          remark: this.otherForm.remark
        }
        addOrEditOtherApply(data).then(response => {
          this.$message({
            message: '其他收款申请提交成功',
            type: 'success'
          })
          this.otherForm = {
            nature: '银行收款'
          }
          this.otherVisible = false
          this.otherloading = false
          this.otherImgList = []
          this.getData()
        }).catch(() => {
          this.otherloading = false
        })
      })
    },

    // 深化收款
    deepenApplyEdit(formName) {
      this.deepenRules.imgids[0].required = this.deepenForm.nature === '银行收款';
      this.$refs[formName].validate((valid) => {
        if (!valid)return false;
        if (this.deepenForm.nature == '账户抵扣' && this.deepenForm.balance < this.deepenForm.money) {
          this.$message({
            message: '账户余额不足',
            type: 'warning'
          })
          return false;
        }
        if (this.deepenloading) return false;
        this.deepenloading = true
        const data = {
          applyid: 0,
          userid: this.user.dUserid,
          groupid: this.user.dGroupid,
          paycontent: '深化收款',
          nature: this.deepenForm.nature,
          delid: this.deepenForm.delid,
          receipttime: this.deepenForm.receipttime,
          amount: this.deepenForm.money,
          aid: this.deepenForm.aid,
          card: this.deepenForm.card,
          img: this.deepenForm.imgids ? this.deepenForm.imgids.join(',') : '',
          name: this.deepenForm.name || '深化收款',
          remark: this.deepenForm.remark
        }
        addOrEditOtherApply(data).then(response => {
          this.$message({
            message: '深化收款申请提交成功',
            type: 'success'
          })
          this.deepenForm = {
            nature: '银行收款'
          }
          this.deepenVisible = false
          this.deepenloading = false
          this.deepenImgList = []
          this.getData()
        }).catch(() => {
          this.deepenloading = false
        })
      })
    },

    getDealerAccountList() {
      this.tableLoading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        content: this.searchForm.search,
        groupid: this.user.dGroupid
      }
      getDealerAccountList(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.tableLoading = false
      }).catch(() => {
        this.tableLoading = false
      })
    },
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getDealerAccountList()
      } else {
        this.searchForm.search = ''
        this.getDealerAccountList()
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getDealerAccountList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getDealerAccountList()
    },
    goDealerAccount(row) {
      this.$router.push(`/work/account_detail/${row.dealer_id}`)
    },

    exportAfterExcel() {
      const data = {
        userid: this.user.dUserid
      }
      this.btnLoading = true
      let file = null
      excelAfterAccountList(data).then(response => {
        file = response.data
        this.downLoad(file)
        this.btnLoading = false
      }).catch(() => {
        this.btnLoading = false
      })
    },
    exportRebaceExcel() {
      const data = {
        userid: this.user.dUserid
      }
      this.btnLoading = true
      let file = null
      excelRebaceAccountList(data).then(response => {
        file = response.data
        this.downLoad(file)
        this.btnLoading = false
      }).catch(() => {
        this.btnLoading = false
      })
    },

    exportExcel() {
      const data = {
        userid: this.user.dUserid,
        content: this.searchForm.search,
        date: this.searchForm.date,
        groupid: this.user.dGroupid
      }
      this.btnLoading = true
      let file = null
      excelDealerAccountList(data).then(response => {
        file = response.data
        this.downLoad(file)
        this.btnLoading = false
      }).catch(() => {
        this.btnLoading = false
      })
    },
    downLoad(file) {
      const _this = this
      let xhr = new XMLHttpRequest()
      xhr.open('GET', file.dPath, true)
      xhr.responseType = 'blob'
      xhr.onload = function() {
        if (this.status === 200) {
          let blob = this.response
          let a = document.createElement('a')
          a.download = file.dName
          a.href = window.URL.createObjectURL(blob)
          a.target = '_blank'
          a.click()
          _this.excelLoading = false
          const h = _this.$createElement
          _this.$msgbox({
            title: '下载提示',
            message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
              h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
              h('a',
                { attrs: {
                  href: window.URL.createObjectURL(blob),
                  target: '_blank',
                  download: `${file.dName}`,
                  style: 'color: #409EFF;text-decoration:underline;'
                }}, `点击这里`),
              h('span', null, `重新下载。`)
            ]),
            showCancelButton: false,
            confirmButtonText: '关闭',
            beforeClose: (action, instance, done) => {
              done()
            }
          }).then(action => {
          })
        }
      }
      xhr.send()
    },

  }
}
</script>

<style lang="scss" scoped>
.dashboard {
  &-container {
    margin: 30px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
.tcf-row{
  .card{
    .card-body{
      .card-title{
        font-weight: 500;
        color: #404852;
        margin-bottom: 22px;
        font-size: 14px;
        .search-mode{
          width: 300px;
          position: relative;
          float: right;
          margin-top: -10px;
          .search-input{
            background-color: #F2F6FC;
            border:0;
            height: 40px;
            line-height: 40px;
            border-radius: 4px;
            color: #606266;
            padding: 0 40px 0 15px;
            -webkit-appearance: none;
            font-size: 12px;
            width: 100%;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            outline: 0;
            &::-webkit-input-placeholder {
              color: #C0C4CC;
            }
            &::-ms-input-placeholder {
              color: #C0C4CC;
            }
          }
          .search-btn{
            position: absolute;
            right: 0;
            height: 40px;
            width: 40px;
            line-height: 40px;
            top: 0;
            border: 0;
            background: transparent;
            text-align: center;
            padding: 0;
          }
        }
      }
      .card-content{
        .group-filter{
          width: 100%;
          padding: 0 30px 0 0 ;
          margin: 0 ;
          position: relative;
          li{
            width: 100%;
            list-style: none;
            position: relative;
            padding-left: 20px;
            padding-top: 15px;
            padding-bottom: 15px;
            cursor: pointer;
            border-radius: 2px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            &.active{
              background: #f5f7fa;
              color:#409EFF;
            }
            &:hover{
              color:#409EFF;
            }
          }
        }
        .client-sex{
          width: 16px!important;
          height: 16px!important;
          vertical-align: -4px!important;
        }
        .el-table::before{
          height: 0!important;
        }
        .el-pagination{
          margin-top: 20px;
        }
      }
    }
  }
}
</style>
